import React from 'react';

import { ArticleMode } from '../../../common/spdCore/validation/schemas';
import { useNavigation } from '../../../common/navigation';

import { ExamsSpecialistView } from './ExamsSpecialistView';

export const ExamsNeurologistView: React.FC = () => {
  const nav = useNavigation();

  return (
    <ExamsSpecialistView
      mode="neurologist"
      articleMode={ArticleMode.Neurologist}
      tabReadyTitle={'Badania neurologiczne do obsługi'}
      tabAllTitle={'Wszystkie badania neurologiczne'}
      onClick={nav.examTestsNeurologist}
    />
  );
};
